'use strict';

module.exports = [
    {
        level: '1',
        code: 'PR',
        label: 'Private Residence',
        description:
            'A living arrangement within a private residence for single family.'
    },
    {
        level: '2',
        code: 'R',
        label: 'Retirement Community',
        description: 'Retirement Community'
    },
    {
        level: '3',
        code: 'SL',
        label: 'Assisted Living',
        description:
            'Assisted living in a single family residence for persons with physical, behavioral, or functional health, or socio-economic challenges. There may or may not be on-site supervision but the housing is designed to assist the client with developing independent living skills. Community based services may be provided.'
    },
    { level: '4', code: 'G', label: 'Group Home', description: 'Group Home' },
    {
        level: '5',
        code: 'N',
        label: 'Nursing Home',
        description: 'Nursing Home'
    },
    { level: '6', code: 'I', label: 'Institution', description: 'Institution' },
    {
        level: '7',
        code: 'HL',
        label: 'Homeless',
        description: 'Living arrangements lacking a permanent residence.'
    }
];
